import React, { useEffect, useState } from 'react'
import ScmModuleStyle from '../styles/scm.module.css';
import profit from '../assets/profit.png';
import stock_icon_new from '../assets/stock_icon_new.png';
import PlaceOrders from './PlaceOrders';
import RequestBid from './RequestBid';
import Button from '../../common/Button';

const BidsOrders = ({ pOrderActivityHeight, setPOrderActivityHeight, simObj, setSimObj, formatNum, setError, toggleSimulation, setToggleSimulation, isRequestLoading, getMonth, setIsShowRequestBid,skipWalkThruPopups, scmPopup, setScmPopup,activeBidOrderTab,setActiveBidOrderTab,isOverlay,isBidOrderOpen,setIsBidOrderOpen}) => {
    const [isUtilizedActive, setIsUtilizedActive] = useState(false);

    const changeTabs = (e) => {

        // if (document.querySelector(".popup-container ui.stackable.two.column.grid") == null) {
        const target = window.$(e.target).closest('.item.tab-item')[0];
        const parent = target.parentNode;
        let grandparent = parent.parentNode;
        // Remove all current selected tabs
        parent
            .querySelectorAll('[aria-selected="true"]')
            .forEach((t) => {
                t.setAttribute("aria-selected", false);
                t.setAttribute("tabindex", "-1");
                t.style.borderBottom = "none";
                t.style.color = "rgba(0,0,0,.6)";
                t.classList.remove(`${ScmModuleStyle["active"]}`);
                t.classList.remove(`active`);
            });

        // Set this tab as selected
        target.setAttribute("aria-selected", true);
        target.removeAttribute("tabindex")
        target.style.borderBottom = "2px solid #B90000"
        target.style.color = "#B90000"
        target.classList.add(`${ScmModuleStyle["active"]}`);
        target.classList.add(`active`);

        // Hide all tab panels
        if (grandparent.classList.contains("stackable")) {
            grandparent
                .querySelectorAll('[role="tabpanel"]')
                .forEach((p) => {
                    p.setAttribute("hidden", true);
                    p.classList.remove(`active`);
                });
        }
        else {
            grandparent
                .querySelectorAll(`#panelList>div[role="tabpanel"]`)
                .forEach((p) => {
                    p.setAttribute("hidden", true);
                    p.classList.remove(`active`);
                });
        }
        // Show the selected panel
        let targetId = target.getAttribute("aria-controls");
        if (document.getElementById(targetId) != null) {
            document
                .getElementById(targetId)
                .removeAttribute("hidden");
            document
                .getElementById(targetId).classList.add(`active`)
        }
        setTimeout(() => {
            if (document.getElementById(targetId) != null && !isOverlay) {
                document.getElementById(targetId).tabIndex = 0;
                document.getElementById(targetId).focus();
            }
        }, 1000);
        // }
        (target.getAttribute("id") == "tab_2") ? setIsUtilizedActive(true) : setIsUtilizedActive(false);

    }
    const handleInvestmentTabs = () => {
        const tabs = document.getElementsByClassName(`${ScmModuleStyle['decision-tabs']}`)[0].querySelectorAll(`[role="tab"]`);
        const tabList = document.getElementsByClassName(`${ScmModuleStyle['decision-tabs']}`)[0]

        // Add a click event handler to each tab
        tabs.forEach((tab) => {
            tab.addEventListener("click", (e) => {
                changeTabs(e);
                const tabs = document.getElementsByClassName(`${ScmModuleStyle['decision-tabs']}`)[0].querySelectorAll(`[role="tab"]`);
                let activeTab =  window.$(e.target).closest('.item.tab-item')[0];
                  tabs.forEach((tab) => {
                    tab.setAttribute("tabindex", "-1");
                  });
                  setTimeout(() => {
                    activeTab.setAttribute("tabindex", "0");
                    tabFocus = Array.from(tabs).indexOf(activeTab);
                  }, 0)
            });
        });

        // Enable arrow navigation between tabs in the tab list
        let tabFocus = 0;

        tabList.addEventListener("keydown", (e) => {
            // Move right
            const tabs = document.getElementsByClassName(`${ScmModuleStyle['decision-tabs']}`)[0].querySelectorAll(`[role="tab"]`);
            if ((e.shiftKey && e.key === 'Tab') || (e.key == "Tab")) {
                let activeTab = document.getElementsByClassName(`${ScmModuleStyle['decision-tabs']}`)[0].querySelector(`[role="tab"].active`)
                tabs.forEach((tab) => {
                    tab.setAttribute("tabindex", "-1");
                });
                setTimeout(() => {
                    if(activeTab != null){
                        activeTab.setAttribute("tabindex", "0");
                        tabFocus = Array.from(tabs).indexOf(activeTab);
                    }
                }, 100)
            }
            if (e.key === "ArrowRight" || e.key === "ArrowLeft" || e.key === "ArrowUp" || e.key === "ArrowDown" || e.key === 'Home' || e.key === 'End') {
                tabs[tabFocus].setAttribute("tabindex", -1);
                if (e.key === "ArrowRight" || e.key === "ArrowDown") {
                    tabFocus++;
                    // If we're at the end, go to the start
                    if (tabFocus >= tabs.length) {
                        tabFocus = 0;
                    }
                    // Move left
                } else if (e.key === "ArrowLeft" || e.key === "ArrowUp") {
                    tabFocus--;
                    // If we're at the start, move to the end
                    if (tabFocus < 0) {
                        tabFocus = tabs.length - 1;
                    }
                }
                else if (e.key === "Home") {
                    tabFocus = 0;
                }
                else if (e.key === "End") {
                    tabFocus = tabs.length - 1;
                }
                e.preventDefault();
                tabs[tabFocus].setAttribute("tabindex", 0);
                tabs[tabFocus].focus();
            }
        });
        // tabs[0].click();
    }
    useEffect(() => {
        setPOrderActivityHeight(document.getElementsByClassName(`${ScmModuleStyle['make-decision-activity']}`)[0].clientHeight)
        console.log(simObj?.laststate)
    }, [simObj?.laststate]);
    useEffect(() => {
        handleInvestmentTabs();
    }, []);
    return (
        <div className={`ui accordion ${ScmModuleStyle['make-decisions']}`}>
            <div className={`title active ${ScmModuleStyle['title']} ${ScmModuleStyle['decision-heading']}`} style={isBidOrderOpen ? { borderBottom : "1px solid rgba(34, 36, 38, .15)"} : {}} onClick={()=>{
                    setIsBidOrderOpen(isBidOrderOpen => !isBidOrderOpen)
                }}>
                <div>
                    <img src={stock_icon_new} alt="" />
                    <h3 id="BidsOrdersHeading">Bids / Orders</h3>
                </div>
                <button className='chevron-btn' aria-expanded={isBidOrderOpen} aria-labelledby="BidsOrdersHeading">
                    <i class={`chevron ${isBidOrderOpen ? "up" : "down"} icon`} aria-hidden="true"></i>
                </button>
               
            </div>
            <div className={`content active`}>
                <div className={`transition visible ${ScmModuleStyle['decision-main']}`} id='decisionMain' style={{display : "block !important"}}>
                    <div role="tablist" aria-label="Investment tabs" className={`${ScmModuleStyle['decision-tabs']}`}>
                        <button
                            className={`item tab-item ui button active ${ScmModuleStyle['ui']} ${ScmModuleStyle['button']}`}
                            role="tab"
                            aria-selected="true"
                            aria-controls="panel_1"
                            id="tab_1"
                            tabIndex="0"
                            style={{ borderBottom: "2px solid #B90000", color: "#B90000" }}
                            onClick={()=>setActiveBidOrderTab("request bid")}
                        >
                            REQUEST BID
                        </button>
                        <button
                            className={`item tab-item ui button ${ScmModuleStyle['ui']} ${ScmModuleStyle['button']} place-order-btn ${ScmModuleStyle['place-order-btn']} ${scmPopup?.placeOrders ? `show ${ScmModuleStyle.show}` : ''}`}
                            role="tab"
                            aria-selected="false"
                            aria-controls={`panel_2`}
                            id="tab_2"
                            tabIndex="-1"
                            onClick={()=>setActiveBidOrderTab("place order")}
                            >
                            PLACE ORDERS
                        </button>
                        {
                            scmPopup?.placeOrders ? <div className={`ui pointing label ${ScmModuleStyle.ui} ${ScmModuleStyle.pointing} ${ScmModuleStyle.label} ${ScmModuleStyle['place-order-popup']}`} role='dialog' aria-modal="true" aria-label="Place orders popup" tabIndex={-1}>
                                <p>When you’re ready you can revisit this area and click Place Orders.</p>
                                <div className={`${ScmModuleStyle.mt10} ${ScmModuleStyle.dflex}`}>
                                <Button btnName="Skip Walk-Thru" btnWidth="130" clickEventHandler={skipWalkThruPopups} />
                                <Button btnName="Next" btnId="btnNext" btnParentClassName={`${ScmModuleStyle.ml10}`} btnWidth="80" clickEventHandler={()=>{
                                    setScmPopup((prevScmPopup) => ({...prevScmPopup, ['placeOrders'] : false, ['bidsFromsupplier'] : true}))
                                }} />
                                </div>
                            </div> : ''
                        }
                    </div>
                    <div id="panelList" className={`${ScmModuleStyle['panel-list']}`}>
                        <div id='panel_1' className={`${ScmModuleStyle['_panel_1']}`} role="tabpanel" tabIndex="0" aria-labelledby="tab_1">
                            <RequestBid simObj={simObj} setSimObj={setSimObj} formatNum={formatNum} setError={setError} toggleSimulation={toggleSimulation} setToggleSimulation={setToggleSimulation} isRequestLoading={isRequestLoading} setIsShowRequestBid={setIsShowRequestBid} getMonth={getMonth} />
                        </div>
                        <div id="panel_2" role="tabpanel" className={`${ScmModuleStyle['_panel_2']} ${ScmModuleStyle['panel-2']}`} tabIndex="0" aria-labelledby="tab_2" hidden>
                            <PlaceOrders simObj={simObj} setSimObj={setSimObj} formatNum={formatNum} setError={setError} toggleSimulation={toggleSimulation} setToggleSimulation={setToggleSimulation} isRequestLoading={isRequestLoading} isUtilizedActive={isUtilizedActive} getMonth={getMonth} scmPopup={scmPopup} setScmPopup={setScmPopup} isOverlay={isOverlay}/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BidsOrders